import { ArrowLeft } from "lucide-react";

interface LogoMarkProps {
  /** True while the parent link is hovered/focused — swaps shield → arrow. */
  hovered: boolean;
  /** Pixel size of the outer box. Defaults to 36 (the wordmark pairing). */
  size?: number;
}

/**
 * LogoMark — heraldic shield with a hover/focus swap to a back-arrow.
 * Extracted once for every auth page (was duplicated three times in the
 * original LoginPage / SignUpPage / CompleteSignUpPage trio).
 */
export function LogoMark({ hovered, size = 36 }: LogoMarkProps) {
  const inner = Math.round((size * 5) / 9);
  return (
    <div
      className="relative overflow-hidden border border-[var(--border)]"
      style={{ width: size, height: size, background: "var(--brand-surface)" }}
      aria-hidden="true"
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: hovered ? 0 : 1,
          transform: hovered ? "translateX(-12px)" : "translateX(0)",
          transition: "all 300ms ease",
        }}
      >
        <svg width={inner} height={inner} viewBox="0 0 64 64" fill="var(--brand)" aria-hidden="true" focusable="false">
          <polygon points="8,52 8,6 18,6 24,14 24,52" />
          <polygon points="40,52 40,18 46,10 56,10 56,52" />
          <rect x="4" y="54" width="56" height="5" />
        </svg>
      </div>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: hovered ? 1 : 0,
          transform: hovered ? "translateX(0)" : "translateX(12px)",
          transition: "all 300ms ease",
        }}
      >
        <ArrowLeft width={inner} height={inner} className="text-[var(--foreground)]" />
      </div>
    </div>
  );
}
